import { apiGetGame, apiPutIncrementGamePlay, apiPostGamePlayed } from '@/api';
import * as types from '@/store/mutation-types';

// Models
import GAME from '@/store/models/game';

// initial state
const state = {
  data: GAME
};

// mutations
const mutations = {
  [types.RECEIVED_GAME] (state, data) {
    state.data = data;
  },

  [types.RESET_GAME] (state) {
    state.data = GAME;
  },
};

const actions = {
  getGame: ({ commit }, slug) => {
    return apiGetGame(slug, { include: 'stats,casinos.stats,casinos.casinoGameStats,offers' })
      .then(({ data }) => commit(types.RECEIVED_GAME, data))
      .catch(error => {
        console.log(error)
        if (error.data.status_code === 403) alert('You are not authorised to view this game.')
      });
  },

  incrementGamePlay: ({ commit }, slug) => {
    return apiPutIncrementGamePlay(slug)
      .catch(error => console.log(error));
  },

  setGameAsPlayed: ({ commit, rootState }, game) => {
    // Adds games to user recentGames object
    return apiPostGamePlayed(game.slug)
      .then(({ data }) => commit(types.RECEIVED_RECENTLY_PLAYED_GAMES, data))
      .catch(error => console.log(error));
  },
};

const getters = {
  game (state) {
    return state.data;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/game.js